import { createFileRoute } from '@tanstack/react-router'

// The parent route renders the page.
export const Route = createFileRoute('/_authenticated/customer-comms/store-ai/')({
  staticData: { title: 'Store AI' },
  component: () => null,
})
